export default "__VITE_ASSET__BZn8O7zm__"